import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FooterInfoService {

  public isProfressional: boolean;

  constructor() {
    this.isProfressional = false;
   }
}
